export var LinkTypes;
(function (LinkTypes) {
    LinkTypes["REGULAR"] = "regular";
    LinkTypes["BUTTON"] = "button";
})(LinkTypes || (LinkTypes = {}));
